"use client";

import { c as _c } from "react/compiler-runtime";
import WavesLayout from "@/components/waves/layout/WavesLayout";
import WavesView from "@/components/waves/WavesView";
export default function WavesPageClient() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <WavesLayout><WavesView /></WavesLayout>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}